module.exports = __webpack_public_path__ + "img/logo_pic-text.f327ab8c.svg";